var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.12903 0.146793L1.19497 0.205025L4.9 3.9095L8.60502 0.205025L8.67097 0.146793C8.94557 -0.0667242 9.34264 -0.0473135 9.59497 0.205025C9.84731 0.457364 9.86672 0.854426 9.65321 1.12903L9.59497 1.19497L5.8905 4.9L9.59497 8.60502C9.86834 8.87839 9.86834 9.32161 9.59497 9.59497C9.34264 9.84731 8.94557 9.86672 8.67097 9.65321L8.60502 9.59497L4.9 5.8905L1.19497 9.59497L1.12903 9.65321C0.854426 9.86672 0.457364 9.84731 0.205025 9.59497C-0.0473135 9.34264 -0.0667242 8.94557 0.146793 8.67097L0.205025 8.60502L3.9095 4.9L0.205025 1.19497C-0.0683417 0.921608 -0.0683417 0.478392 0.205025 0.205025C0.457364 -0.0473135 0.854426 -0.0667242 1.12903 0.146793Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bd3a32c4.svg";
export { ForwardRef as ReactComponent };